import { create } from 'zustand';

export type NotificationSeverity = 'success' | 'error' | 'warning' | 'info';

interface NotificationState {
  open: boolean;
  message: string;
  severity: NotificationSeverity;
  show: (message: string, severity?: NotificationSeverity) => void;
  close: () => void;
}

export const notificationStore = create<NotificationState>((set) => ({
  open: false,
  message: '',
  severity: 'info',
  show: (message, severity = 'info') => set({ open: true, message, severity }),
  close: () => set({ open: false }),
}));

export const useNotificationStore = notificationStore;
